import React, { Fragment } from 'react';
import ReactDom from 'react-dom';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Image from '../h3Image';

/**
 *
 */
export default function H3Modal({
  children, className, isOpen, onClose, showHeader, title, noHeaderBorder,
}) {
  if (!isOpen) return null;
  return ReactDom.createPortal(
    <Fragment>
      <div className="h3-modal__overlay" />
      <div className={`h3-modal__wrapper ${className || ''}`}>
        <div className={`h3-modal__title ${noHeaderBorder ? 'h3-modal__title-no-border' : ''}`}>
          {showHeader && (
            <H3Text
              text={title}
              className="h3-modal__title-text"
            />
          )}
          <H3Image
            src={closeIcon}
            className="h3-modal__close-icon"
            onClick={() => {
              onClose();
            }}
          />
        </div>
        {children}
      </div>
    </Fragment>, document.getElementById('portal'),
  );
}

H3Modal.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  noHeaderBorder: PropTypes.bool,
};
